export const CheckPermissionsDesign = (response: any, permissionType: string): boolean => {
    if (!response || !response.assets) return false;
    for (const asset of response.assets) {
      if (!asset.design) continue;
      for (const website of asset.design) {
        if (website[permissionType]) {
          return true; // Permission exists
        }
      }
    }
    return false; // Permission not found
  };